import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'

export class FrontOfficeAlert extends Component {
  static propTypes = {
    onPay: PropTypes.func,
    adjustment: PropTypes.object,
    downloadReceipt: PropTypes.func
  };

  constructor (props) {
    super(props)
    this.state = {
      showAdjustmentDetails: false,
      payment: 'SPORTELLO_CONTANTI'
    }
  }

  render () {
    const {
      total,
      payed,
      mark1,
      mark2,
      mark3
    } = this.props.adjustment
    return (
      <div
        className={'col-md-7 alert ' + (payed ? 'alert-success' : 'alert-danger')}
        role="alert"
      >
        {!!payed && (
          <div>
            Hai saldato il pagamento 2018 - &nbsp;
            <NavLink to="/user-area/order-history" className="btn btn-info">Scarica Ricevuta</NavLink>
          </div>
        )}
        {!payed && (
          <React.Fragment>
            <div>
              <h4 style={{fontWeight: 'bold'}}>
                Devi ancora saldare il pagamento 2018 per i seguenti contrassegni
              </h4>
              <ul style={{padding: 0, margin: '1rem 0 2rem', listStyle: 'none', color: 'black', fontWeight: 'bold'}}>
                {mark1 && (<li>● {mark1}</li>)}
                {mark2 && (<li>● {mark2}</li>)}
                {mark3 && (<li>● {mark3}</li>)}
              </ul>
              <h4>
                Totale da pagare: €{' '}
                {Number(total).toLocaleString('it-IT', {
                  minimumFractionDigits: 2, maximumFractionDigits: 2
                })}
              </h4>
            </div>
            <button
              style={{marginRight: '1rem'}}
              className="btn btn-info"
              onClick={this.props.onPay}>
              Paga Ora
            </button>
            <span style={{fontWeight: 'bold'}}>(Attenzione) - Le operazioni utente sono disabilitate fino all'avvenuto saldo del pagamento 2018</span>
          </React.Fragment>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Alert/FrontOfficeAlert.js